import { createSlice } from '@reduxjs/toolkit';
import { productGroupDelete } from './productGroupAsyncThunk';

const productGroupDeleteSlice = createSlice({
  name: "productGroup",
  initialState: {
    isLoading: false,
    isSuccess: false,
    failCode: 0,
  },
  reducers: {},
  extraReducers: {
    [productGroupDelete.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.failCode = 0;
    },
    [productGroupDelete.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [productGroupDelete.rejected]: (state, action) => {
      state.isLoading = false;
      state.failCode = action.payload.status;
    },
  },
});

export default productGroupDeleteSlice.reducer;